import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { FunctionComponent, PropsWithChildren, ReactNode } from 'react';
import { createPortal } from 'react-dom';
import styles from './GenericModal.module.scss';

interface GenericModalProps extends PropsWithChildren {
    footer: ReactNode;
    className?: string;
    onClose?: () => void;
}

const GenericModal: FunctionComponent<GenericModalProps> = props => {
    return createPortal(
        <div className={styles.overlay}>
            <div className={clsx(styles.modal, props.className)}>
                <div className={styles.header}>
                    <FontAwesomeIcon
                        icon={faTimes}
                        fontSize={18}
                        onClick={props.onClose}
                        className={styles.closeIcon}
                    />
                </div>
                <div className={styles.body}>{props.children}</div>
                <div className={styles.footer}>{props.footer}</div>
            </div>
        </div>,
        document.body
    );
};

export default GenericModal;
